import { AuthLevel, generateApiPath } from '@guiker/api-definition'

const paths = {
  quebecLease: generateApiPath({ prefix: AuthLevel.JWT_AUTH, name: 'quebec-lease' }),
}

export { paths }
